import React from 'react';
import clsx from 'clsx';

export const TimesIcon = ({ width, height, fill, className, ...rest }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 10 10'
      className={clsx('icon', 'icon-times', className)}
      aria-hidden='true'
      {...rest}
    >
      <path
        d='M15 6.007 13.993 5 10 8.993 6.007 5 5 6.007 8.993 10 5 13.993 6.007 15 10 11.007 13.993 15 15 13.993 11.007 10z'
        transform='translate(-5 -5)'
        fill={fill}
      />
    </svg>
  );
};

TimesIcon.defaultProps = {
  width: 13,
  height: 13,
  fill: 'var(--flushed)',
  className: ''
};
